module.exports = __webpack_public_path__ + "static/media/email.90605344.png";